import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectApartmentsFilter } from 'shared/selectors/advancedFilters/apartments/selectApartmentsFilter';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const ApartmentsContainer: FC = () => {
  const { label, value, options } = useSelector(selectApartmentsFilter);

  const onChange = useFilterChangeCallback();

  const handleApartmentsChange = useCallback(
    (newValue: boolean | null) => {
      onChange({ action: 'setApartments', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleApartmentsChange} />
    </AdvancedFilterRow>
  );
};
